import img1 from '../assets/img/Agriculture.jpg';
import img2 from '../assets/img/driverdemand.webp';
import img3 from '../assets/img/bigmartsale.jpg';
import img4 from '../assets/img/lock-door.jpeg';
import img5 from '../assets/img/Password-Based-Circuit.jpg';
import img6 from '../assets/img/RetailPrice.webp';
import img7 from '../assets/img/senitiment.webp';
import img8 from '../assets/img/stock.webp';
import img9 from '../assets/img/wheather.jpg';
import img10 from '../assets/img/smart-home.png';

const Dataa=[
    {
        imgUrl: img5,
        id:2,
        category:"hardware",
        text:"Circuit Breaker Using Password."
    },
    {
        imgUrl: img3,
        id:3,
        category:"IoT",
        text:"BigMart Sales Prediction ML Project"
    },
    {
        imgUrl: img4,
        id:4,
        category:"IoT",
        text:"Home Automation System"
    },
    {
        imgUrl: img1,
        id:1,
        category:"IoT",
        text:"Smart Agriculture System"
    },
    {
        imgUrl: img9,
        id:5,
        category:"AI/ML",
        text:"Weather Reporting System"
    },
    {
        imgUrl: img6,
        id:6,
        category:"AI/ML",
        text:" Stock Prices Predictor using TimeSeries"
    },
    {
        imgUrl: img7,
        id:7,
        category:"AI/ML",
        text:"Social Media Sentiment Analysis Using Twitter Dataset"
    },
    {
        imgUrl: img8,
        id:8,
        category:"AI/ML",
        text:"Retail Price Optimization ML Project"
    },
    {
        imgUrl: img2,
        id:9,
        category:"AI/ML",
        text:"Driver Demand Prediction"
    },
    {
        imgUrl: img10,
        id:10,
        category:"hardware",
        text:"Wireless Lock System Through OTP."
    }

];

export default Dataa;